module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-07-f43fcd118a5914a27af0dee19167ed64.jpg";